import { DeepPartial, DeepReadonly } from 'ts-essentials';
import { IShapeModelProps } from '@src/slide/domain/ui-model/element-modeles/Interface/model-props/shape-model-props.interface';
import { IPictureModelProps } from '@src/slide/domain/ui-model/element-modeles/Interface/model-props/picture-model-props.interface';
import { IAddonData, IApplicationNonVisualPropsData, DeltaOf } from '@tencent/slide-sdk-model';
import { ADD_ON_MODE_MAP } from '@src/slide/domain/ui-model/converter/node-property/sdk-ui-enum-map/addon-mode';
import { invertMap } from '@src/slide/infrastructure/module/independent/object/map-invert';

/**
 * 插件
 */
export class AddonConverter {
    /**
     * 插件的sdk -> ui 映射
     * @param sdkData
     * @param uiData
     */
    public static convertPartialDataFromSdkToUi(
        sdkData?: DeepReadonly<DeepPartial<IAddonData>>,
        uiData?: IShapeModelProps | IPictureModelProps,
    ): void {
        if (!uiData) {
            return;
        }
        if (sdkData) {
            const obj = {
                displayMode: ADD_ON_MODE_MAP.get(sdkData.displayMode!),
                embedUrl: sdkData.embedUrl, // 缺失则视频不可用
                iframeId: sdkData.iframeId, // 插件悬浮bar
                title: sdkData.title,
                extraData: sdkData.extraData,
                originUrl: sdkData.originUrl, // 视频封面
                aid: sdkData.aid, // 公式插件编辑
                type: sdkData.type || '', // 区分公式插件
                docElement: sdkData.docElement,
            };
            Object.keys(obj).forEach((p) => {
                if (!obj[p]) {
                    delete obj[p];
                }
            });
            if (Object.keys(obj).length) {
                uiData.addon = obj;
            }
        } else {
            delete uiData.addon;
        }
    }

    /**
     * 插件的ui -> sdk 映射
     * @param uiData
     * @param sdkData
     */
    public static convertPartialDataFromUiToSdk(
        uiData: DeepReadonly<DeepPartial<IShapeModelProps | IPictureModelProps>>,
        sdkData: DeltaOf<IApplicationNonVisualPropsData>,
    ): void {
        if (uiData.addon) {
            const obj = {
                extraData: uiData.addon.extraData,
                aid: uiData.addon.aid,
                type: uiData.addon.type || '',
                docElement: uiData.addon.docElement,
            };
            const shapeAddon = (uiData as IShapeModelProps).addon;
            if (shapeAddon) {
                Object.assign(obj, {
                    displayMode: invertMap(ADD_ON_MODE_MAP).get(shapeAddon.displayMode),
                    embedUrl: shapeAddon.embedUrl,
                    iframeId: shapeAddon.iframeId,
                    title: shapeAddon.title,
                    originUrl: shapeAddon.originUrl,
                });
            }
            Object.keys(obj).forEach((p) => {
                if (!obj[p]) {
                    delete obj[p];
                }
            });
            if (Object.keys(obj).length) {
                sdkData.addon = obj;
            } else {
                sdkData.addon = null;
            }
        } else {
            sdkData.addon = null;
        }
    }
}
